import React, { useEffect, useState } from "react";
import "./Popup.css"
import 'reactjs-popup/dist/index.css';
import { Button, Modal, Spinner } from "react-bootstrap";
import { apiGetCommunityById, apiJoinCommunity } from "../api/api";
import { Alert, Chip, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const CommunityPopup = () => {
  const [alertData, setAlertData] = useState(null)
  const [communityData, setCommunityData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const {state} = useLocation()
  let user = state ? state.user : null
  let content = state ? state.content: null

  const onHide = () => navigate("/explore")

  const fetchCommunity = async () => {
    console.log("popup fetch community")
    content && 
      apiGetCommunityById(content._id).then((res) => {
        setCommunityData(res.data)
        setIsLoading(false)
      }).catch((err) => {
        err.response && alert(err.response.data.detail)
    })
  }

  const handleJoin = async (id) => {
    console.log("sending join request")
    setIsLoading(true)
    apiJoinCommunity(id)
      .then((res)=>{
        console.log(res.data)
        onHide()
      }).catch((err)=>{
        console.log(err.response)
        err.response && alert(err.response.data.detail)
      })
  }

  useEffect(() => {
    console.log(state)
    setCommunityData(null)
    state && fetchCommunity()
  }, [])
  

  const displayButton = () => {
    if (user && communityData && !isLoading){
      if(communityData.pendingMembers.includes(user.email)){
        return(
          <Button disabled data-testid="community-popup-button" variant="warning">
            Waiting for approval
          </Button>
        )
      } else if(communityData.publicMembers.includes(user.email) || communityData.admin === user.email){
        return(
          <Button data-testid="community-popup-button" variant="warning" onClick={() => { navigate(`/community/${communityData._id}`) }}>
            Go to community
          </Button>
        )
      } else{
        return(
          <Button data-testid="community-popup-button" variant="warning" onClick={() => { handleJoin(communityData._id) }}>
            Request to join
          </Button>
        )
      }
    } else {
      return(
        <Spinner animation="border" />
      )
    }
  }

  return (
    <Modal show={true} onHide={onHide}>
      <Modal.Header closeButton>
          <Modal.Title>{content && content.name}</Modal.Title>
      </Modal.Header>
      {alertData && <Alert onClose={() => {setAlertData(null)}} severity="success">This is a success alert — check it out!</Alert>} 
      <Modal.Body>
        {
          content && 
            (
              <>
                  <p style={{whiteSpace: "pre-line", maxHeight:"30vh", overflow:"scroll"}}>{content.shortDescription}</p>
                  <Stack direction="row" spacing={1}>
                    {
                      content.tags && content.tags.map((item,index) => 
                        <Chip key={index} label={item} variant="outlined" />
                      )
                    }
                  </Stack>
              </>
            )
        }

      </Modal.Body>
      <Modal.Footer>
        {displayButton()}
      </Modal.Footer>
    </Modal>
  );
};
 
export default CommunityPopup;
